module.exports = __webpack_public_path__ + "static/img/scene-sljs.bb7b722.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/scene/scene-sljs.png
// module id = PFjN
// module chunks = 1